export default __webpack_public_path__ + "static/media/Mark of the Ancient Sands.ad71ea7d.jpg";